export default "__VITE_ASSET__n5Jk72Kw__"